export const selectProperties = state => state.properties


// WEBPACK FOOTER //
// ./selectors/properties.js